import { Box, Divider, Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { PortfolioRowSkeleton } from "web_myplann/Portfolio/Components/Redesign/ListItem/PortfolioRowSkeleton";

type Props = {
	rows: number;
};

export const PortfolioCategorySectionSkeleton: FC<Props> = ({ rows }) => {
	const theme = useTheme();

	return (
		<Box>
			<Stack
				direction="row"
				alignItems="center"
				gap={theme.spacingTokens.sm}
				px={theme.spacingTokens.lg}
				pt={2.4}
				pb={theme.spacingTokens.sm}
				bgcolor={theme.palette.grey[50]}
			>
				<Skeleton variant="text" width={120} height={14} animation="wave" />
				<Skeleton
					variant="rounded"
					width={20}
					height={16}
					animation="wave"
					sx={{ borderRadius: "999px" }}
				/>
			</Stack>
			<Box bgcolor="background.paper">
				{Array.from({ length: rows }).map((_, index) => (
					// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
					<Box key={index}>
						<PortfolioRowSkeleton />
						{index < rows - 1 && <Divider redesigned />}
					</Box>
				))}
			</Box>
		</Box>
	);
};
